import api from 'api/apiInstance';
import { objectToURLParams } from 'helpers/utils';

interface ClientCaseFactFindLetterOfAuthorityInformationRequestPrintGetOptions {
  assetNumber: number;
}

export function clientCaseFactFindLetterOfAuthorityInformationRequestPrintApi(path: string) {
  const generatePath = (
    params: ClientCaseFactFindLetterOfAuthorityInformationRequestPrintGetOptions
  ) => {
    const options = {
      'data[attributes][asset_number]': params.assetNumber,
    };

    return `${path}?${objectToURLParams(options)}`;
  };

  return {
    path,
    GET: (params: ClientCaseFactFindLetterOfAuthorityInformationRequestPrintGetOptions) =>
      api.get<File>(generatePath(params)),
    GETPath: (params: ClientCaseFactFindLetterOfAuthorityInformationRequestPrintGetOptions) =>
      generatePath(params),
  };
}
